import { Injectable, enableProdMode } from '@angular/core';
import { environment } from '../../environments/environment';
@Injectable()
export class GlobalService {
  public apiHost: string;
  public setting: any = {};
  constructor() {
    this.apiHost = environment.apiHost;
    //enableProdMode()
  }

  loadGlobalSettingsFromSessionStorage(): void {
      if (sessionStorage.getItem('backend-setting') != null) {
          this.setting = JSON.parse(sessionStorage.getItem('backend-setting'));
    }
  }
}
